import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import { EditInvoicePayload, EditInvoiceResponse } from './types';

interface EditInvoiceArgs {
  publicToken: string;
  payload: EditInvoicePayload;
}

/**
 * Hook to apply corrections to an invoice via PATCH /api/v2/invoices/{public_token}/
 */
export function useEditInvoice() {
  const queryClient = useQueryClient();

  return useMutation<EditInvoiceResponse, Error, EditInvoiceArgs>({
    mutationFn: async ({ publicToken, payload }: EditInvoiceArgs) => {
      const response = await api.patch<EditInvoiceResponse>(
        `/v2/invoices/${publicToken}/`,
        payload
      );
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['invoice', variables.publicToken] });
      queryClient.invalidateQueries({ queryKey: ['invoices'] });
    },
  });
}
